module.exports = __webpack_public_path__ + "media/images/zoomify_image-f4e468940f6e2e90d2bcf91c36767fab.png";